import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { isMcpFlow } from '@frontend/web/hooks/useMcpFlow';
import { AUTHENTICATED_HOME_ROUTE, createFileRoute, redirect } from '@frontend/web/utils/router';
import { lazy, Suspense } from 'react';
import { validateLoginSearch } from './-publicSearch';

const LazyLogin = lazy(() => import('./-login').then((module) => ({ default: module.Login })));

const LoginRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazyLogin />
  </Suspense>
);

export const Route = createFileRoute('/login')({
  beforeLoad: async ({ context, search }) => {
    if (isMcpFlow()) {
      throw redirect({
        to: '/signup/mcp/complete',
      });
    }
    if (context.authentication?.isAuthenticated) {
      throw redirect({ to: search.redirect || AUTHENTICATED_HOME_ROUTE });
    }
  },
  component: LoginRouteComponent,
  validateSearch: validateLoginSearch,
});
